import { useMutation, useQueryClient } from '@tanstack/react-query';
import { hideApplicant } from '@company/services/application/api';
import QueryKeys from '@constants/queryKeys';

export function useHideCandidate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      jobAssignmentId,
      hide,
    }: {
      jobAssignmentId: number;
      hide: boolean;
    }) => hideApplicant(jobAssignmentId, hide),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.JobDetail.CANDIDATES],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.JobDetail.CANDIDATE_COUNTERS],
      });
    },
  });
}
